<div class="container my-5">
  <div class="row justify-content-center">
    <div class="col-lg-8 text-center">
      <img src="https://www.csrgs.org/assets/management/Profiles/president.jpg" alt="President Image"
        class="img-fluid rounded shadow-sm mb-4 president-img" />

      <div class="president-message text-start">
        <h5 class="fw-bold mb-3">Message from President</h5>
        <p>
          Chhatrapati Sambhaji Raje Global School & Jr. College, Ambajogai. We
          strain every nerve to bring out innate potentials of students and
          offer them guidance to bloom wherever they are planted. All the
          diverse activities categorized under scholastic and co-scholastic
          areas have been placed diligently to provide adequate opportunities
          to all the budding stars of tomorrow to excel in the field of their
          choice and acumen. We aim to make our student physically fit,
          mentally alert and emotionally balanced. May God bless his choicest
          blessings on the students and the collective effort of the management
          and the staff to ensure on today that tomorrow will take care of them
          itself.
        </p>
        <p class="fw-bold text-end mt-4">President - Adv. Madhav Jadhav</p>
      </div>
    </div>
  </div>
</div>